import React from "react";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components2/YhBox";

export const DataBox = () => {
    return (
        <YhBox title="">
            <DataTable />
        </YhBox>
    )
}